import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide4TwoStages.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide4TwoStages(_props: SlideProps) {
  const c = useSlideCopy(copy)
  const STEPS = [
    { number: 1, title: c.step1Title, blurb: c.step1Body },
    { number: 2, title: c.step2Title, blurb: c.step2Body },
    { number: 3, title: c.step3Title, blurb: c.step3Body },
  ]

  return (
    <div className="flex flex-col items-center text-center px-4 mx-auto max-w-5xl">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1, ease }}
        className="text-xs sm:text-sm uppercase tracking-[0.25em] text-slate-400 font-semibold"
      >
        {c.eyebrow}
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.25, ease }}
        className="mt-4 text-5xl sm:text-6xl font-semibold text-slate-900 tracking-tight leading-[1.05]"
      >
        {c.title}
      </motion.h2>

      {/* Cards with chevrons */}
      <div className="mt-10 w-full grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr_auto_1fr] gap-4 items-stretch">
        {STEPS.map((step, idx) => (
          <>
            {idx > 0 && (
              <motion.div
                key={`arrow-${idx}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.6 + idx * 0.1, ease }}
                className="hidden lg:flex items-center justify-center text-slate-300"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="dir-flip">
                  <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </motion.div>
            )}
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 + idx * 0.12, ease }}
              className="rounded-2xl border border-slate-200 bg-white shadow-sm p-6 text-start"
            >
              <h3 className="text-2xl sm:text-3xl font-semibold text-slate-900 tracking-tight whitespace-nowrap">
                {step.number}. {step.title}
              </h3>
              <p className="text-lg sm:text-xl text-slate-500 leading-relaxed mt-3">
                {step.blurb}
              </p>
            </motion.div>
          </>
        ))}
      </div>
    </div>
  )
}
